import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type CancelOpenDockWarehouseAppointmentParams = {
  shipmentUUID: string
  stopIndex: number
}

export type CancelOpenDockWarehouseAppointmentFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function cancelOpenDockWarehouseAppointmentFactory({
  shipmentRepository,
}: CancelOpenDockWarehouseAppointmentFactoryDependencies) {
  return async function submit(
    params: CancelOpenDockWarehouseAppointmentParams,
    config?: { signal?: AbortSignal }
  ) {
    const { shipmentUUID, stopIndex } = params
    try {
      return await shipmentRepository.cancelOpenDockWarehouseAppointment({
        shipmentUUID,
        stopIndex,
        config,
      })
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not cancel appointment', { cause: error as Error })
    }
  }
}

export function cancelOpenDockWarehouseAppointment(
  params: CancelOpenDockWarehouseAppointmentParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const submit = cancelOpenDockWarehouseAppointmentFactory({ shipmentRepository })

  return submit(params, config)
}
